import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import assign from 'lodash/assign';
import {
  buildSrcSet,
  makeHttps,
  changeAssetDomain
} from '../../../utils/cloudinary_asset_util';

export default class Image extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
      alt,
      src,
      assetSizes,
      noLazy,
      baseClass,
      modifier,
      jwId,
      aspectRatioImage,
      loading
    } = this.props; 
    const secureSrc = makeHttps(src).replace('.jpg','.webp').replace('.png','.webp');
    const fcDomainAsset = changeAssetDomain(secureSrc);
    let sourceAttribs = {
      media: '(max-width: 40em)',
      'data-sizes': get(assetSizes, 'small.sizes'),
      'data-srcset': buildSrcSet(assetSizes, 'small.srcset', fcDomainAsset)
    };
    let imgAttribs = {
      'data-sizes': get(assetSizes, 'large.sizes'),
      'data-srcset': buildSrcSet(assetSizes, 'large.srcset', fcDomainAsset),
      className: `${
        noLazy ? '' : 'lazyload'
      } ${baseClass} ${baseClass}--${modifier}`,
      loading
    };

    if (jwId) {
      const index = fcDomainAsset.indexOf('https://cdn.jwplayer.com/thumbs/');
      if (index) {
        const jwUrl = fcDomainAsset.slice(index);

        sourceAttribs['data-srcset'] = jwUrl.replace(jwId, `${jwId}-320`);
        imgAttribs['data-srcset'] = jwUrl.replace(jwId, `${jwId}-320`);
      }
    }

    try {
      if (aspectRatioImage) {
        const largeImages = get(assetSizes, 'large.srcset', []);
        if (largeImages) {
          const largestImage = largeImages[largeImages.length - 1];
          const imageOptions = largestImage.split(',');
          if (imageOptions) {
            let ratioWidth = 16;
            let ratioHeight = 9;
            if (imageOptions[1].includes('ar_')) {
              const imageRatioOption = imageOptions[0].split('_');
              if (imageRatioOption[1].includes(':')) {
                const ratio = imageRatioOption[1].split(':');
                [ratioWidth, ratioHeight] = ratio;
              }
            }
            if (imageOptions[0].includes('w_')) {
              const imageSizeOption = imageOptions[0].split('_');
              const width = imageSizeOption[1];
              const height = Math.round(ratioHeight / ratioWidth * width);
              imgAttribs.width = width;
              imgAttribs.height = height;
            }
          }
        }
      }
    } catch (err) {
      console.warn(`Error loading image: ${err}`);
    }

    // if (width && height) {
    //   imgAttribs.width = width;
    //   imgAttribs.height = height;
    // }

    // if (!noLazy) {
    //   imgAttribs.loading = 'lazy';
    // }

    function removeData(str) {
      return str.replace('data-', '');
    }

    function removeDataAttrs(obj) {
      const correctedParams = assign({}, obj);
      // eslint-disable-next-line no-restricted-syntax
      for (const attr in correctedParams) {
        if (/^data-/.test(attr)) {
          let strippedAttr = removeData(attr);
          strippedAttr = strippedAttr.replace('srcset', 'srcSet');
          correctedParams[strippedAttr] = correctedParams[attr];
          delete correctedParams[attr];
        }
      }

      return correctedParams;
    }

    if (noLazy) {
      imgAttribs = removeDataAttrs(imgAttribs);
      sourceAttribs = removeDataAttrs(sourceAttribs);
    }
    if (src && !isEmpty(assetSizes)) {
      return (
        <picture>
          <source
            media={sourceAttribs.media}
            sizes={sourceAttribs.sizes}
            srcSet={sourceAttribs.srcset}
          />
          {noLazy ? (
            <img {...imgAttribs} alt={alt} />
          ) : (
            <React.Fragment>
              <img {...imgAttribs} alt={alt} />
            </React.Fragment>
          )}
        </picture>
      );
    }
    return (
      <picture>
        <img
          alt={alt}
          data-src={src}
          className={`${noLazy ? '' : 'lazyload'}`}
        />
      </picture>
    );
  }
}

Image.defaultProps = {
  noLazy: false,
  assetSizes: {},
  baseClass: '',
  modifier: '',
  jwId: '',
  aspectRatioImage: false,
  loading: ''
};

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  baseClass: PropTypes.string,
  modifier: PropTypes.string,
  src: PropTypes.string.isRequired,
  noLazy: PropTypes.bool,
  assetSizes: PropTypes.shape({
    large: PropTypes.shape({
      sizes: PropTypes.string,
      srcset: PropTypes.arrayOf(PropTypes.string)
    }),
    small: PropTypes.shape({
      sizes: PropTypes.string,
      srcset: PropTypes.arrayOf(PropTypes.string)
    })
  }),
  jwId: PropTypes.string,
  aspectRatioImage: PropTypes.bool,
  loading: PropTypes.string
};
